module.exports = __webpack_public_path__ + "static/img/guanwang23.png.463dd97e.png";